var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResultEmptyItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "68px",
    viewBox: "0 0 68 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "44.9802361%",
    fx: "50%",
    fy: "44.9802361%",
    r: "100%",
    gradientTransform: "translate(0.500000,0.449802),rotate(90.000000),scale(1.000000,0.949473),translate(-0.500000,-0.449802)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#462849",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#330632",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-2",
    cx: 34,
    cy: 34,
    r: 34
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "game-reslut-empty-mobile",
    transform: "translate(-34.000000, -185.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(34.000000, 185.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Untitled-2.pngl-Copy"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#radialGradient-1)",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    stroke: "#DAD2F9",
    strokeWidth: 3,
    cx: 34,
    cy: 34,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    stroke: "#824293",
    strokeWidth: 4,
    cx: 34.0810811,
    cy: 34.0810811,
    r: 31.0810811
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy",
    transform: "translate(13.477477, 7.351351)",
    fill: "#FFFFFF",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.334599,0.546963109 C7.48786746,1.15412503 6.57232029,2.01852111 5.28980406,2.47764621 C4.00718364,2.9368954 2.84323947,2.81690243 2.68997102,2.20974051 C2.53670257,1.60270267 3.45224974,0.738306598 4.73476596,0.279057408 C6.01738638,-0.180067694 7.18133055,-0.0601988162 7.334599,0.546963109",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.004914,4.47972973 C2.004914,5.05067938 1.55610515,5.51351351 1.002457,5.51351351 C0.448808857,5.51351351 0,5.05067938 0,4.47972973 C0,3.90878008 0.448808857,3.44594595 1.002457,3.44594595 C1.55610515,3.44594595 2.004914,3.90878008 2.004914,4.47972973",
    id: "Fill-3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultEmptyItem);
export default __webpack_public_path__ + "static/media/result-empty-item.82f84e11e5dc980b08db05640227aa59.svg";
export { ForwardRef as ReactComponent };